import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { haveIntersectionBetweenTwoArrays } from '../../utils/helpers';

export const MainMenuWrapper = styled('nav')`
  ${({ theme: { spacing } }) => css`
    margin-left: ${spacing.px40};
    display: flex;
    flex-direction: column;
  `}
`;

export const MainMenuList = styled('ul')`
  ${({ theme: { spacing } }) => css`
    margin: ${spacing.none};
    padding-left: ${spacing.none};
    list-style-type: none;
    display: flex;
    height: 80px;
    align-items: stretch;
    min-width: 720px;
    @media screen and (max-width: 1200px) {
      display: none !important;
    }
  `}
`;

function isActive(title, pathname) {
  const activeSubpages = ['GDTVItem', 'MediaItem'];
  const currentPageIsAnyCommunicationActiveSubpage = haveIntersectionBetweenTwoArrays(
    pathname.split('/'),
    activeSubpages
  );

  if (title === 'Communication' && currentPageIsAnyCommunicationActiveSubpage) {
    return true;
  }
  if (title === 'TradeCI' && pathname.includes('Campaigns')) return true;
  if (title === 'Insights' && pathname.includes('Trade/Dashboard')) return true;
  if (title === 'CI' && pathname.includes('CampaignItem')) return true;

  return pathname.indexOf(title) !== -1;
}

export const MainMenuItem = styled('li')`
  ${({ theme: { spacing, fontWeight }, currentTitle, active }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin: ${(props) =>
      props.isBornlogic ? `${spacing.none} ${spacing.px10}` : `${spacing.none} ${spacing.px16}`};

    @media screen and (max-width: 1650px) {
      margin: ${(props) =>
        props.isBornlogic
          ? `${spacing.none} ${spacing.px8} ${spacing.none} ${spacing.none}`
          : `${spacing.none} ${spacing.px16}`};
    }
    ${isActive(currentTitle, active) &&
    css`
      h6 {
        font-weight: ${fontWeight.bold} !important;
        color: #2328eb !important;
      }
    `}
  `}
`;

export const MainMenuLink = styled(Link)`
  ${({ theme: { fontWeight, colors } }) => css`
    text-decoration: none;
    align-items: center;
    display: flex;
    height: 80px;
    h6 {
      position: relative;
      font-weight: ${fontWeight.normal};
      color: ${colors.blueGrey2};
    }
    :focus {
      h6 {
        font-weight: ${fontWeight.light};
        color: #2328eb;
      }
    }
    :hover {
      h6 {
        color: #2328eb;
      }
    }
    @media (max-width: 1200px) {
      height: 20px;
    }
  `}
`;
